import { useQuery } from "@tanstack/react-query";

import {
  PipelineRunLog,
  distributionService,
} from "../services/distributionService";

/**
 * Polling adaptativo del orquestador post-sync §7:
 * - 5s si el último run está `running`
 * - 30s en estado terminal (completed/failed/partial) o sin runs
 *
 * Consumido por DistribucionPostSyncMonitor en /odoo/production-sync.
 */
export function useDistributionPostSyncRuns(limit = 10): {
  data: PipelineRunLog[] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: ["distribution", "post-sync-runs", limit],
    queryFn: () => distributionService.getPostSyncRuns(limit),
    refetchInterval: (q) => {
      const runs = q.state.data;
      const isRunning = runs?.[0]?.overall_status === "running";
      return isRunning ? 5000 : 30000;
    },
    staleTime: 2000,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  };
}
